import { Component, OnInit, HostListener } from '@angular/core';
import { MatBottomSheet} from '@angular/material/bottom-sheet';
import { EnquiryComponent } from '../enquiry/enquiry.component';
import { SearchService } from '../services/search.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { DataService } from '../services/data.service';
import { LocationMappingService } from '../services/location-mapping.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  public toggle=0;
  searchText: string = '';
  private currentLocation: string | null = null;

  openTab($event, tabName) {
    // Declare all variables
    var i,  tablinks;
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName('tablinks');
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' active', '');
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tabName).style.display = 'block';
    $event.currentTarget.className += ' active';
    this.toggle=0;
  }


  constructor(
    private bottomSheet: MatBottomSheet,
    private searchService: SearchService,
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private locationMappingService: LocationMappingService
  ) {
    // Subscribe to route changes to track current location
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentLocation = this.getLocationFromUrl();
    });
  }

  ngOnInit() {
    this.dataService.getBranches().subscribe();
    this.dataService.getCourses().subscribe();
    this.currentLocation = this.getLocationFromUrl();
  }

  getLocationFromUrl(): string | null {
    // Get current URL and extract location slug
    const url = this.router.url;
    const segments = url.split('/').filter(s => s && !s.includes('?'));
    
    // Check if first segment is a location slug
    if (segments.length > 0) {
      const potentialSlug = segments[0];
      const location = this.locationMappingService.getLocationAndStore(potentialSlug);
      if (location) {
        return location;
      }
    }
    
    // If no location in URL, check localStorage
    return this.locationMappingService.getStoredLocation();
  }

  onSearchTextChange() {
    this.searchService.changeSearchText(this.searchText);
    this.router.navigate(['/courses'])
  }

  openBottomSheet(): void {
    this.bottomSheet.open(EnquiryComponent,{
      data:{
        source : "home page",
        location: this.currentLocation
      }
    });
  }

  displayMenu(){
    if(this.toggle){
      this.toggle=0;
    }
    else{
      this.toggle=1;
    } 
  }

  
}
